import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { NoahSessionShortInfoRequest, NoahSessionOptionWithDate } from '../models/noah-sessions';

@Injectable({
  providedIn: 'root'
})
export class NoahDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public checkNoahActionChangedAsync(request: NoahSessionShortInfoRequest, timeout: Promise<any>): Promise<boolean> {
    return this.httpClient.postJsonAsync<boolean>('noahSessions/CheckNoahActionChanged', request, timeout, false);
  }

  public getAppointmentNoahSessionOptionsAsync(appointmentId: number, timeout: Promise<any>): Promise<NoahSessionOptionWithDate[]> {
    return this.httpClient.getJsonAsync<NoahSessionOptionWithDate[]>('noahSessions/GetAppointmentNoahSessionOptions', { appointmentId }, timeout, false);
  }
}
